"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ensign = exports.ResolutionError = void 0;
const types_1 = require("./types");
const is = __importStar(require("./is"));
const DUMP = '__DUMP__';
const DEBUG = '__DEBUG__';
class ResolutionError {
    constructor(message) {
        this.message = message;
    }
}
exports.ResolutionError = ResolutionError;
// From https://github.com/darkskyapp/string-hash
const hash = (str0) => {
    const str = `${str0}`;
    let hash = 5381;
    let i = str.length;
    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
};
function resolveValues(groupedOverrides, ctx, environment) {
    const result = {};
    function resolver(ov, depth) {
        if (depth >= 10) {
            return new ResolutionError('Maximum callback stack exceeded.');
        }
        switch (ov.type) {
            case types_1.OverrideType.Boolean:
            case types_1.OverrideType.Number:
            case types_1.OverrideType.String:
                return ov.value;
            case types_1.OverrideType.Error:
                return new ResolutionError(ov.value);
            case types_1.OverrideType.All:
                return ov.value.every((x) => resolver(x, depth + 1) === true);
            case types_1.OverrideType.Any:
                return ov.value.some((x) => resolver(x, depth + 1) === true);
            case types_1.OverrideType.None: {
                return ov.value.every((x) => {
                    const next = resolver(x, depth + 1);
                    return next === false || next instanceof ResolutionError;
                });
            }
            case types_1.OverrideType.Not: {
                const next = resolver(ov.value, depth + 1);
                return next === false || next instanceof ResolutionError;
            }
            case types_1.OverrideType.BeforeDate: {
                return new Date() < ov.value;
            }
            case types_1.OverrideType.AfterDate: {
                return new Date() > ov.value;
            }
            case types_1.OverrideType.PercentOf: {
                const [entity, percentage] = ov.value;
                const id = ctx[entity];
                if (id === undefined) {
                    return new ResolutionError(`Entity "${entity}" not available`);
                }
                const hashedId = hash(id);
                // when percentOf: 0 => always false
                // when percentOf: 100 => always true
                return percentage > hashedId % 100;
            }
            case types_1.OverrideType.Environmnent:
                return ov.value === environment;
            case types_1.OverrideType.Entry: {
                const overrides = groupedOverrides[ov.value];
                for (let i = overrides.length - 1; i > -1; i--) {
                    const override = overrides[i];
                    const next = resolver(override.value, depth + 1);
                    if (next instanceof ResolutionError) {
                        continue;
                    }
                    return next;
                }
            }
            // falls through
            default:
                return new ResolutionError(`Unable to resolve "${ov.value}"`);
        }
    }
    for (const key in groupedOverrides) {
        const overrides = groupedOverrides[key];
        let selectedIndex = 0;
        let values = [
            {
                value: new ResolutionError(`No Provider resolved values for "${key}"`),
                source: 'ensign',
            },
        ];
        for (let i = 0; i < overrides.length; i++) {
            const override = overrides[i];
            const next = resolver(override.value, 0);
            const isCorrectType = typeof next === override.expectedType;
            const isError = next instanceof ResolutionError;
            let resolvedValue;
            if (isCorrectType || isError) {
                resolvedValue = {
                    value: next,
                    source: override.source,
                };
            }
            else {
                // if it's not the correct type, but it's not an error == the wrong type was encoded into definition or overrides
                resolvedValue = {
                    value: new ResolutionError(`Expected that "${key}" would resolve to ${override.expectedType}, but was ${typeof next}`),
                    source: override.source,
                };
            }
            if (isCorrectType) {
                // use i + 1 here because "selectedIndex" is preseeded with 0
                selectedIndex = i + 1;
            }
            values = values.concat(resolvedValue);
        }
        result[key] = {
            key,
            values,
            selectedIndex,
        };
    }
    return result;
}
function normalizeOverrideValue(value) {
    if (is.boolean(value)) {
        return {
            type: types_1.OverrideType.Boolean,
            value,
        };
    }
    if (is.number(value)) {
        return {
            type: types_1.OverrideType.Number,
            value,
        };
    }
    if (is.string(value)) {
        return {
            type: types_1.OverrideType.String,
            value,
        };
    }
    const couldNotNormalizeError = (reason) => {
        return {
            type: types_1.OverrideType.Error,
            value: `Could not normalize ${JSON.stringify(value)}: ${reason}`,
        };
    };
    const keys = Object.keys(value);
    // TODO: I think this check might be redundant with other type checking
    // but I don't know how to eliminate it
    if (keys.length === 0) {
        return couldNotNormalizeError('Object can only have one key');
    }
    const type = keys[0];
    const next = value[type];
    if (type === types_1.OverrideType.PercentOf) {
        // We know these are true from our type structure
        const percentSpec = next;
        const entityKeys = Object.keys(percentSpec);
        const entityName = entityKeys[0];
        const percentage = percentSpec[entityName];
        if (isNaN(percentage)) {
            return couldNotNormalizeError(`Percentage is not a number`);
        }
        return {
            type,
            value: [entityName, percentage],
        };
    }
    if (type === 'beforeDate') {
        const date = next;
        if (!is.validDateString(date)) {
            return couldNotNormalizeError('Invalid date');
        }
        return {
            type,
            value: new Date(date),
        };
    }
    if (type === 'afterDate') {
        const date = next;
        if (!is.validDateString(date)) {
            return couldNotNormalizeError('Invalid date');
        }
        return {
            type,
            value: new Date(date),
        };
    }
    if (type === types_1.OverrideType.Environmnent) {
        const env = next;
        return {
            type,
            value: env,
        };
    }
    if (type === types_1.OverrideType.Entry) {
        const entrySelector = next;
        return {
            type,
            value: entrySelector,
        };
    }
    if (type === types_1.OverrideType.Not) {
        const innerValue = next;
        return {
            type,
            value: normalizeOverrideValue(innerValue),
        };
    }
    if (type === types_1.OverrideType.Any) {
        const innerValues = next;
        return {
            type,
            value: innerValues.map((n) => normalizeOverrideValue(n)),
        };
    }
    if (type === types_1.OverrideType.All) {
        const innerValues = next;
        return {
            type,
            value: innerValues.map((n) => normalizeOverrideValue(n)),
        };
    }
    if (type === types_1.OverrideType.None) {
        const innerValues = next;
        return {
            type,
            value: innerValues.map((n) => normalizeOverrideValue(n)),
        };
    }
    // This should be unreachable given the type checking that we do
    return {
        type: types_1.OverrideType.Error,
        value: `Could not normalize ${JSON.stringify(next)} which is of type ${JSON.stringify(type)}`,
    };
}
function groupNormalizedOverrides(props) {
    return props.overrides.reduce((acc, override) => {
        const normalized = normalizeOverride(override, props.featureDefinitions[override.key]);
        const group = acc[normalized.key] !== undefined ? acc[normalized.key] : [];
        return Object.assign(Object.assign({}, acc), { [normalized.key]: group.concat(normalized) });
    }, {});
}
const createDump = (props) => () => props;
const createDebug = (props) => () => {
    const featuresTable = {};
    for (const key in props.groupedResultValues) {
        const definition = props.featureDefinitions[key];
        const resolvedValues = props.groupedResultValues[key];
        const index = resolvedValues.selectedIndex;
        const selected = resolvedValues.values[index] || { value: undefined, source: undefined };
        featuresTable[key] = {
            current: selected.value,
            source: selected.source,
            default: definition.default,
            description: definition.description,
            type: definition.type,
        };
    }
    console.groupCollapsed('Ensign Debugger');
    console.groupCollapsed('overview');
    console.table(featuresTable, ['current', 'source', 'default', 'description', 'type']);
    console.groupEnd();
    for (const key in props.groupedResultValues) {
        const resolvedValues = props.groupedResultValues[key];
        const definition = props.featureDefinitions[key];
        const featureTable = {};
        for (let i = 0; i < resolvedValues.values.length; i++) {
            const resolvedValue = resolvedValues.values[i];
            featureTable[resolvedValue.source] = {
                value: resolvedValue.value,
                wasSelected: i === resolvedValues.selectedIndex,
                isError: resolvedValue.value instanceof ResolutionError,
            };
        }
        console.groupCollapsed(`"${key}" resolution path`);
        console.log(`Expected type: ${definition.type}`);
        console.log(`Description: ${definition.description}`);
        console.log(`Intended expiry: ${definition.intendedExpiry}`);
        console.table(featureTable, ['value', 'wasSelected', 'isError']);
        console.groupEnd();
    }
    console.groupEnd();
};
function normalizeOverride(override, definition) {
    return {
        key: override.key,
        source: override.source,
        value: normalizeOverrideValue(override.value),
        expectedType: definition.type,
    };
}
class Ensign {
    constructor(environment, featureDefinitions, providers) {
        this.environment = environment;
        this.featureDefinitions = featureDefinitions;
        this.providers = providers;
    }
    static create(props) {
        const providers = props.providers || [];
        // NOTE: We still need to do this check since we might be getting this
        // from pure Javascript code rather than TypeScript
        if (!is.featureDefinitions(props.featureDefinitions)) {
            throw new ResolutionError('Error parsing featureDefinitions');
        }
        const environment = is.environment(props.environment) ? props.environment : types_1.Environment.Development;
        return new Ensign(environment, props.featureDefinitions, providers);
    }
    async resolve(context) {
        const props = {
            context,
            featureDefinitions: this.featureDefinitions,
            environment: this.environment,
            providers: this.providers,
        };
        const proms = props.providers.map((provider) => provider.apply(props));
        const overrides = (await Promise.all(proms)).reduce((acc, overrides) => acc.concat(overrides), []);
        // this should warn if it is going to be removed
        const filteredOverrides = overrides.filter((override) => props.featureDefinitions[override.key] !== undefined);
        const groupedNormalizedOverrides = groupNormalizedOverrides({
            overrides: filteredOverrides,
            featureDefinitions: this.featureDefinitions,
        });
        const groupedResultValues = resolveValues(groupedNormalizedOverrides, context, this.environment);
        const result = {};
        for (const key in groupedResultValues) {
            const resolvedValues = groupedResultValues[key];
            const index = resolvedValues.selectedIndex;
            const resolvedValue = resolvedValues.values[index];
            result[key] = resolvedValue.value;
        }
        const dump = createDump({
            ir: [filteredOverrides, groupedNormalizedOverrides, groupedResultValues, result],
            context,
            featureDefinitions: this.featureDefinitions,
            environment: this.environment,
            providers: this.providers,
        });
        Object.defineProperty(result, DUMP, {
            configurable: false,
            writable: false,
            enumerable: false,
            value: dump.bind(null),
        });
        const debug = createDebug({
            featureDefinitions: this.featureDefinitions,
            groupedNormalizedOverrides,
            groupedResultValues,
        });
        Object.defineProperty(result, DEBUG, {
            configurable: false,
            writable: false,
            enumerable: false,
            value: debug.bind(this),
        });
        return Object.freeze(result);
    }
}
exports.Ensign = Ensign;
//# sourceMappingURL=ensign.js.map